import Header from '../../../__Layout/Header';
import React,{useState} from "react";
import Loader from '../../../utils/Loader';
import { useGetStudentCourseOutcomeQuery} from "../../../Services/api";
import {pageUrl} from "../../../utils/constants/constants";
import VideoModal from "./VideoModal";
import "../../../assets/niceapms/assets/css/style.css"
import {Link, useParams } from 'react-router-dom';
export default function CourseOutcome() {   
    const { lpid,unit } = useParams();
    const lpidParam= 'lpid='+lpid+'&elementno='+unit;
    const { 
        data: CourseOutcome,
        isLoading: isGetLoading,
    } = useGetStudentCourseOutcomeQuery({ pageUrl, params: lpidParam });
    const [learningOutcomeId,setLearningOutcomeId] = useState("");
    if(isGetLoading) return  <Loader></Loader>
    return (
        <>
            <Header />
            <main id="main" className="main">
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title">{CourseOutcome?.elementTitle[0]?.element_name}</h5>
                        <section className="section">
                            <div className="row">
                            
                            <div className='col-6 bg-primary text-white pt-3'>
                                <h4>{CourseOutcome?.course_outcome[0]?.element_tag}</h4>
                            </div>
                            <div className='col-4 bg-dark text-white'>
                                <h4>Recommended Learning Hours  {CourseOutcome?.course_outcome[0]?.study_hours}</h4>
                            </div>
                            <div className='col-1'>
                                <Link to={`/student-course-topic/${lpid}/${unit}`} className='btn btn-warning pull-right'>
                                    Back
                                </Link>
                            </div>
                                <div className='col-12 table-responsive'>
                                    <table className="table table-bordered">
                                        <thead className='bg-warning text-dark'>
                                            <tr>
                                                {/* <th className='text-capitalize' scope="col" className="col-1">#</th> */}
                                                <th className='text-capitalize col-1' scope="col" >Learner’s Notes</th> 
                                                 <th className='text-capitalize col-1' scope="col" >Relevant Videos</th> 
                                                <th className='text-capitalize col-1' scope="col" >Supportive Articles/Case Study</th>  
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                               
                                               CourseOutcome?.learning_outcome?.map((item,index) => {
                                                return (
                                                    <tr key={index}>
                                                        {/* <td scope="row">{index+1}</td> */}
                                                        <td>
                                                       
                                                            <Link to={`/paid-course-reading/${item.lpd_id}/${lpid}/${unit}`} className='text-warning'>
                                                               {item.bullet_point}
                                                            </Link>
                                                        </td>
                                                        
                                                        <td> 
                                                            {
                                                              item?.relevant_videos?.map((rv,index) => {
                                                                   return(
                                                                     <>
                                                                     <div className='row'>
                                                                        <div className='col-6'>
                                                                              {rv.title}  
                                                                        </div>
                                                                        <div className='col-6'>
                                                                         
                                                                                    {/* <li>
                                                                                        <button className='text-warning'  data-bs-toggle="modal" onClick={()=>setLearningOutcomeId(rv.video)} data-id={rv.video} data-bs-target="#fullscreenModal" >
                                                                                            Watch
                                                                                        </button>
                                                                                    </li> */}
                                                                                <Link key={index} to={`/video-play/${rv.id}`}  className='text-warning' target="_blank">
                                                                                    watch
                                                                                </Link>
                                                                                
                                                                                
                                                                        </div>
                                                                     </div>      
                                                                     </>
                                                                   )
                                                              })
                                                            }
                                                        </td> 
                                                        <td> 
                                                            {
                                                              item?.articles?.map((ar,index) => {
                                                                   return(
                                                                     <>
                                                                     <div className='row'>
                                                                        
                                                                        <div className='col-6'>
                                                                            
                                                                                {ar.link ? 
                                                                                    <Link key={index} to={ar.link} className='text-warning' target="_blank">
                                                                                        Read Article : {ar.title}
                                                                                    </Link>
                                                                                :
                                                                                ''
                                                                                }   
                                                                        </div>
                                                                     </div>      
                                                                     </>
                                                                   )
                                                              })
                                                            }
                                                            {
                                                              item?.case_studies?.map((cs,index) => {
                                                                   return(
                                                                     <>
                                                                     <div className='row'>
                                                                        <div className='col-6'>
                                                                            <ul key={index}>
                                                                                <li>
                                                                                 
                                                                                {cs.file ? 
                                                                                    <Link to={cs.file} className='text-warning' target="_blank">
                                                                                       case study :  {cs.title}
                                                                                    </Link>
                                                                                :
                                                                                ''
                                                                                }
                                                                                </li>
                                                                            </ul>  
                                                                        </div>
                                                                     </div>      
                                                                     </>
                                                                   )
                                                              })
                                                            }
                                                        </td>                       
                                                    </tr>                                             
                                                    )  
                                                })  
                                          
                                            } 
                                        </tbody>
                                    </table> 
                                </div>
                            </div>
                        </section>  
                    </div>
                    <VideoModal id={learningOutcomeId}/>

                </div>
            </main>
        </>
    );
}
